import React from 'react'
import Header from './Header'
import Indicator from './Indicator'
import Service from './Service'
import Advantages from './Advantages'
import Accordion from './Accordion'
import Contact from './Contact'
import Footer from './Footer'

export default function Home() {
  return (
    <>
    <Header />
    <Indicator />
    <Service />
    <Advantages />
    <Accordion />
    <Contact />
    <Footer />
    </>
  )
}
